export enum ETipoRecolhimento {
  ORIGINAL = 'Original',
  COMPLEMENTAR = 'Complementar',
}

interface TipoRecolhimentoInfo {
  nome: string;
  indice: number;
  label: string;
}

export const TipoRecolhimentoDetalhe: { [key in ETipoRecolhimento]: TipoRecolhimentoInfo } = {
  [ETipoRecolhimento.ORIGINAL]: {
    nome: 'ORIGINAL',
    indice: 0,
    label: 'Original',
  },
  [ETipoRecolhimento.COMPLEMENTAR]: {
    nome: 'COMPLEMENTAR',
    indice: 1,
    label: 'Complementar',
  },
};

export function getValueFromETipoRecolhimentoByIndex(index: number) {
  const labels = Object.values(ETipoRecolhimento);
  return index === -1 ? '-' : labels[index];
}
